import { useState } from 'react'
import { App as AntdApp, Button, Card, Divider, Flex, Form, Input, Typography } from 'antd'
import { GoogleOutlined, LockOutlined, MailOutlined } from '@ant-design/icons'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAuthContext } from '../../../shared/contexts/AuthContext'

const { Title, Text } = Typography

type PasswordLoginForm = {
  email: string
  password: string
}

export function LoginPanel() {
  const { message } = AntdApp.useApp()
  const { loginWithGoogle, loginWithPassword } = useAuthContext()
  const [submitting, setSubmitting] = useState(false)
  const navigate = useNavigate()
  const location = useLocation()
  const redirectLocation = (location.state as { from?: { pathname?: string; search?: string } } | null)?.from
  const redirectTo = redirectLocation?.pathname
    ? `${redirectLocation.pathname}${redirectLocation.search ?? ''}`
    : '/dashboard'

  const submitPasswordLogin = async (values: PasswordLoginForm) => {
    setSubmitting(true)
    try {
      await loginWithPassword(values.email.trim(), values.password)
      message.success('Вход выполнен')
      navigate(redirectTo, { replace: true })
    } catch {
      message.error('Неверный адрес электронной почты или пароль')
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <Card
      className="login-card"
      title={(
        <div className="login-brand">
          <div className="admin-logo-mark">S</div>
          <div><Typography.Text strong>SIESTA MAILER</Typography.Text></div>
        </div>
      )}
    >
      <Flex vertical gap="middle">
        <Title level={3}>Вход в панель</Title>
        <Text type="secondary">Доступ к журналу отправки писем для сотрудников RGL.</Text>
        <Form<PasswordLoginForm> layout="vertical" onFinish={submitPasswordLogin} requiredMark={false}>
          <Form.Item
            label="Адрес электронной почты"
            name="email"
            rules={[
              { required: true, message: 'Введите адрес электронной почты' },
              { type: 'email', message: 'Введите правильный адрес электронной почты' },
            ]}
          >
            <Input
              size="large"
              prefix={<MailOutlined />}
              autoComplete="username"
              placeholder="name@rglservice.kz"
            />
          </Form.Item>
          <Form.Item
            label="Пароль"
            name="password"
            rules={[{ required: true, message: 'Введите пароль' }]}
          >
            <Input.Password
              size="large"
              prefix={<LockOutlined />}
              autoComplete="current-password"
            />
          </Form.Item>
          <Button type="primary" size="large" htmlType="submit" loading={submitting} block>
            Войти
          </Button>
        </Form>
        <Divider plain>или</Divider>
        <Button type="primary" size="large" icon={<GoogleOutlined />} onClick={loginWithGoogle}>
          Войти через Google
        </Button>
      </Flex>
    </Card>
  )
}
